import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { InboxMessagesSetReadInput } from '@libs/types/src/inbox/input-type/inbox-messages-set-read.input';
import { InboxMessageIdsInput } from '@libs/types/src/inbox/input-type/inbox-message-ids.input';
import { InboxMessageLabelAssignInput } from '@libs/types/src/inbox/input-type/inbox-message-label.assign-input';
import { InboxMessageLabelUnassignInput } from '@libs/types/src/inbox/input-type/inbox-message-label.unassign-input';
import { EmailMessageCreateInput } from '@libs/types/src/inbox/input-type/email-message.create-input';
import { EmailMessageGridObject } from '@libs/types/src/inbox/object-type/email-message.object';
import { OkObject } from '@it2go/types';
import { EmailPossibleRecipientsObject } from '@libs/types/src/inbox/object-type/email-possible-recipients.object';

@Injectable({ providedIn: 'root' })
export class EmailMessageGqlService extends GqlServiceV2 {

    getEmailMessages(input: GridInput, frag: string) {
        return this.query<EmailMessageGridObject>(
            `
                query($input: GridInput!) {
                    emailMessage {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    getPossibleRecipients() {
        return this.query<EmailPossibleRecipientsObject>(
            `
                query {
                    emailMessage {
                        getPossibleRecipients {
                            possibleRecipients
                        }
                    }
                }
            `,
        );
    }

    setEmailMessagesRead(input: InboxMessagesSetReadInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessagesSetReadInput!) {
                emailMessage {
                    setRead(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteEmailMessages(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                emailMessage {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    restoreEmailMessages(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                emailMessage {
                    restore(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    createEmailMessage(input: EmailMessageCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: EmailMessageCreateInput!) {
                emailMessage {
                    create(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    assignLabelToEmailMessage(input: InboxMessageLabelAssignInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageLabelAssignInput!) {
                emailMessage {
                    assignLabel(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    unassignLabelFromEmailMessage(input: InboxMessageLabelUnassignInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageLabelUnassignInput!) {
                emailMessage {
                    unassignLabel(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
